// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c4311958","453":"6f39db91","732":"6c877383","977":"4da4b222"}[chunkId] + ".chunk.js";
};